"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('harm', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("g", {
    stroke: "none",
    strokeWidth: props.strokeWidth,
    fill: "none",
    fillRule: "evenodd"
  }, _react.default.createElement("g", null, _react.default.createElement("path", {
    d: "M6,8.38382871 L24.008642,3 L42,8.38382871 L42,19.8406803 C42,31.2135249 34.7657703,41.326774 24.0026245,45.0005035 L24.0026245,45.0005035 C13.2365289,41.3268386 6,31.2113281 6,19.8357126 L6,8.38382871 Z",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    fill: props.outFillColor,
    fillRule: "nonzero",
    strokeLinejoin: props.strokeLinejoin
  }), _react.default.createElement("g", {
    transform: "translate(11.000000, 10.000000)",
    stroke: props.innerStrokeColor,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin,
    strokeWidth: props.strokeWidth
  }, _react.default.createElement("g", {
    transform: "translate(12.843146, 12.843146) rotate(-315.000000) translate(-12.843146, -12.843146) translate(4.343146, 4.343146)"
  }, _react.default.createElement("path", {
    d: "M3,3 L14.3137085,14.3137085",
    transform: "translate(8.656854, 8.656854) rotate(45.000000) translate(-8.656854, -8.656854) "
  }), _react.default.createElement("path", {
    d: "M14.3137085,3 L3,14.3137085",
    transform: "translate(8.656854, 8.656854) rotate(-135.000000) translate(-8.656854, -8.656854) "
  }))))));
});

exports.default = _default;